var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-iaenpd",
    "aria-label": "refund",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 2.4000000000000004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13 19H10C7.239 19 5 16.761 5 14V5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5H14C16.761 5 19 7.239 19 10V19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L5 5L2.5 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16L19 19L22 16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.327a7d164e74ee1ab562e5562d32a3df.svg";
export { ForwardRef as ReactComponent };